module.exports = __webpack_public_path__ + "fonts/ralewaymedium.2f18aa2.ttf";